'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _admin = require('./admin/admin');

var _admin2 = _interopRequireDefault(_admin);

var _login = require('./login/login');

var _login2 = _interopRequireDefault(_login);

var _user = require('./user/user');

var _user2 = _interopRequireDefault(_user);

var _unauthorized = require('./unauthorized/unauthorized');

var _unauthorized2 = _interopRequireDefault(_unauthorized);

var _vehicle = require('./vehicle/vehicle');

var _vehicle2 = _interopRequireDefault(_vehicle);

var _notes = require('./common/notes/notes');

var _notes2 = _interopRequireDefault(_notes);

var _entityManagement = require('./entityManagement/entityManagement');

var _entityManagement2 = _interopRequireDefault(_entityManagement);

var _accessoryManagement = require('./accessoryManagement/accessoryManagement');

var _accessoryManagement2 = _interopRequireDefault(_accessoryManagement);

var _priceManagement = require('./priceManagement/priceManagement');

var _priceManagement2 = _interopRequireDefault(_priceManagement);

var _company = require('./company/company');

var _company2 = _interopRequireDefault(_company);

var _contact = require('./contact/contact');

var _contact2 = _interopRequireDefault(_contact);

var _address = require('./common/address/address');

var _address2 = _interopRequireDefault(_address);

var _contactPhones = require('./common/contactPhones/contactPhones');

var _contactPhones2 = _interopRequireDefault(_contactPhones);

var _contactEmails = require('./common/contactEmails/contactEmails');

var _contactEmails2 = _interopRequireDefault(_contactEmails);

var _gaugeChart = require('./common/gaugeChart/gaugeChart');

var _gaugeChart2 = _interopRequireDefault(_gaugeChart);

var _enquiry = require('./enquiry/enquiry');

var _enquiry2 = _interopRequireDefault(_enquiry);

var _welcomeCentre = require('./welcomeCentre/welcomeCentre');

var _welcomeCentre2 = _interopRequireDefault(_welcomeCentre);

var _messaging = require('./messaging/messaging');

var _messaging2 = _interopRequireDefault(_messaging);

var _dashboard = require('./dashboard/dashboard');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _promise = require('./promise/promise');

var _promise2 = _interopRequireDefault(_promise);

var _reports = require('./reports/reports');

var _reports2 = _interopRequireDefault(_reports);

var _finance = require('./finance/finance');

var _finance2 = _interopRequireDefault(_finance);

var _omniSearch = require('./omniSearch/omniSearch');

var _omniSearch2 = _interopRequireDefault(_omniSearch);

var _webEnquiries = require('./webEnquiries/webEnquiries.service');

var _webEnquiries2 = _interopRequireDefault(_webEnquiries);

var _kpiAnalytics = require('./kpiAnalytics/kpiAnalytics');

var _kpiAnalytics2 = _interopRequireDefault(_kpiAnalytics);

var _leadMonitor = require('./leadMonitor/leadMonitor');

var _leadMonitor2 = _interopRequireDefault(_leadMonitor);

var _privacyPolicy = require('./privacyPolicy/privacyPolicy');

var _privacyPolicy2 = _interopRequireDefault(_privacyPolicy);

var _accounting = require('./accounting/accounting');

var _accounting2 = _interopRequireDefault(_accounting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var componentModule = _angular2.default.module('app.components', [_admin2.default, _login2.default, _user2.default, _unauthorized2.default, _vehicle2.default, _notes2.default, _entityManagement2.default, _accessoryManagement2.default, _priceManagement2.default, _company2.default, _address2.default, _contactPhones2.default, _contactEmails2.default, _contact2.default, _enquiry2.default, _welcomeCentre2.default, _messaging2.default, _dashboard2.default, _promise2.default, _reports2.default, _finance2.default, _omniSearch2.default, _gaugeChart2.default, _kpiAnalytics2.default, _leadMonitor2.default, _privacyPolicy2.default, _accounting2.default]).service('webEnquiriesService', _webEnquiries2.default).name;

exports.default = componentModule;


// WEBPACK FOOTER //
// ./client/app/components/components.js